import ICommand from "./ICommand";
import {useAppDispatch, useAppSelector} from "../hooks";
import {setMessages} from "../redux/messages";
import {selectPlayingChess, setPlayingChess} from "../redux/chess";

export const useChessCommand = (): ICommand => {
  const dispatch = useAppDispatch()
  const playingChess = useAppSelector(selectPlayingChess)

  return {
    help(): string {
      return '- chess\t\t\t\t\t:: shows or hides the chess board';
    },

    async process(msg: string): Promise<void> {
      dispatch(setMessages([]))
      dispatch(setPlayingChess(!playingChess))
    },

    matches(msg: string): boolean {
      return ['chess'].includes(msg.toLowerCase().trim())
    }
  };
}